















































































import { Component, PropSync, Vue } from 'vue-property-decorator';
import UpdateProofOfAddressModalViewModel
  from '@/vue-app/view-models/components/user-profile/user-profile-tabs/user-profile-my-documents-tab/update-proof-of-address/update-proof-of-address-modal-view-model';

@Component({
  name: 'UpdateProofOfAddressModal',
  components: {
    UpdateProofOfAddressChooseYourDocuments: () => import('./UpdateProofOfAddressChooseYourDocuments.vue'),
    UpdateProofOfAddressData: () => import('./UpdateProofOfAddressData.vue'),
    UpdateProofOfAddressAttachYourDocument: () => import('./UpdateProofOfAddressAttachYourDocument.vue'),
  },
})
export default class UpdateProofOfAddressModal extends Vue {
  @PropSync('isOpen', { type: Boolean, required: true })
  synced_is_open!: boolean;

  update_address_view_model = Vue.observable(new UpdateProofOfAddressModalViewModel(this));

  closeModal() {
    this.synced_is_open = false;
  }

  async endProcess() {
    await this.update_address_view_model.updateProofOfAddress();
    this.synced_is_open = false;
  }
}
